//Please add the language resource
const leadtime = {

  msg:{
  }
};
export default leadtime



// WEBPACK FOOTER //
// ./src/page/md/leadtime/lang/leadtime.en.js